import { Sparkles, ArrowRight } from 'lucide-react';

export default function PaywallBanner() {
  return (
    <div className="mb-6 rounded-2xl border border-amber-400/30 bg-gradient-to-r from-amber-500/10 via-orange-500/10 to-yellow-500/10 p-4">
      <a
        href="/settings"
        className="flex items-center justify-between gap-3 group"
      >
        <p className="text-xs md:text-sm text-amber-100 font-medium">
          <Sparkles size={16} className="inline mr-2 text-amber-300" />
          Sblocca Premium: categorie illimitate, grafici avanzati → 5€/mese
        </p>
        <span className="inline-flex items-center gap-1 text-xs md:text-sm text-amber-300 group-hover:text-amber-200 transition-colors">
          Upgrade
          <ArrowRight size={14} />
        </span>
      </a>
    </div>
  );
}